// import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Axios from 'axios'
import React, { Fragment, useEffect, useState } from 'react'
import { useAlert } from 'react-alert'
import { Table } from 'react-bootstrap'
import LoadingPage from '../../pages/LoadingPage'

const cores = ['#F9FAFB', '#EFF1F3', '#E4E7EB', '#DADEE3', '#CED4DA']
const desabilitado = '#eec6c6'

export default function NewTree({
  path,
  columns,
  onSelect,
  setTreeAction,
  enableTotals = true,
}) {
  const alert = useAlert();
  const [iconsController, setIconsController] = useState({})
  const [estruturasOrganizacionais, setEstruturasOrganizacionais] = useState(null)
  const [estruturaSelecionada, setEstruturaSelecionada] = useState(null)
  const [filtro, setFiltro] = useState({})
  const [isTabelaNormal, setIsTabelaNormal] = useState(false)
  const [showOnlyAtivos, setShowOnlyAtivos] = useState(false)
  const [loading, setLoading] = useState(false)

  const getColor = (nivel) => cores[nivel % cores.length]

  const handleIcon = (id, item) => {
    setIconsController((prev) => ({
      ...prev,
      [id]: prev[id] ? { ...prev[id], expandir: !prev[id].expandir } : { item, expandir: true },
    }))
  }

  const handleSelected = (estruturaSelecionada) => {
    setEstruturaSelecionada(estruturaSelecionada)
    onSelect(estruturaSelecionada)
  }

  const render = (id, filho, nivel) => {
    if (!iconsController[id] || !iconsController[id].expandir) return null
    console.log(iconsController)
    const filhos = estruturasOrganizacionais.filter((item) => (item.estruturaOrganizacionalPai ? item.estruturaOrganizacionalPai.id === id : false))

    if (!filhos.length) {
      setIconsController((prev) => ({
        ...prev,
        [id]: { filho, expandir: false },
      }))
    }
    return filhos.map((filho) => renderizarEstrutura(filho, nivel))
  }

  const renderizarEstrutura = (estruturaOrganizacional, nivel = 0) => {
    const temFilhos = estruturasOrganizacionais.some((item) =>
      item.estruturaOrganizacionalPai && item.estruturaOrganizacionalPai.id === estruturaOrganizacional.id
    )

    return (
      <Fragment>
        <tr
          className={`${estruturaSelecionada === estruturaOrganizacional ? 'table-primary' : ''}`}
          style={{ backgroundColor: estruturaOrganizacional.ativo === false ? desabilitado : getColor(nivel), cursor: 'pointer' }}
          key={estruturaOrganizacional.id}
          onClick={() => handleSelected(estruturaOrganizacional)}
        >
          {isTabelaNormal ? (
            <td></td>
          ) : (
            <td style={{ textAlign: 'center', verticalAlign: 'middle' }} onClick={() => handleIcon(estruturaOrganizacional.id, estruturaOrganizacional)}>
              <div>
                {temFilhos && (
                  <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    {iconsController[estruturaOrganizacional.id] ? (iconsController[estruturaOrganizacional.id].expandir ? '-' : '+') : '+'}
                  </span>
                )}
              </div>
            </td>
          )}
          {enableTotals && (
            <Fragment>
              <td>{estruturaOrganizacional.estruturaOrganizacionalTipo ? estruturaOrganizacional.estruturaOrganizacionalTipo.nome : ''}</td>
            </Fragment>
          )}
          <td>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {nivel > 0 && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '8px',
                  fontSize: '14px',
                  color: '#6c757d',
                  marginLeft: nivel > 1 ? `${(nivel - 1) * 20}px` : '0px'
                }}>
                  {nivel === 1 ? '└─' : '└─'}
                </div>
              )}
              <span style={{ marginLeft: nivel > 0 ? '0' : '0' }}>
                {estruturaOrganizacional.codigo}
              </span>
            </div>
          </td>
          <td>{estruturaOrganizacional.nome}</td>
          {enableTotals && (
            <Fragment>
              <td>{estruturaOrganizacional.quantidadeFuncionarios}</td>
              <td>{estruturaOrganizacional.quantidadeHistoricaFuncionarios}</td>
            </Fragment>
          )}
        </tr>
        {isTabelaNormal ? null : render(estruturaOrganizacional.id, estruturaOrganizacional, nivel + 1)}
      </Fragment>
    )
  }

  const handleFilter = async (coluna, value) => {
    setFiltro((prev) => {
      const filtroNovo = { ...prev }

      if (value) {
        filtroNovo[coluna] = { compare: '%%', value: `string:${value}` }
      } else {
        delete filtroNovo[coluna]
      }

      return filtroNovo
    })
  }

  useEffect(() => {
    const handleAtivar = async (id, ativo) => {
      try {
        setLoading(true)
        await Axios.post(`${path}/mudar-ativo`, {
          id,
          ativo,
        })
        const url = `${path}?limit=2000&offset=0`
        const { data } = await Axios.get(url)
        if (enableTotals) {
          const qtdFuncionarios = `${path}/total`
          const { data: qtd } = await Axios.get(qtdFuncionarios)
          const estruturasComQuantidadeFuncionarios = data.data.list.map((estrutura) => {
            const qtdFuncionarios = qtd.data.find((quantidade) => quantidade.estruturaOrganizacionalId === estrutura.id)
            return {
              ...estrutura,
              quantidadeFuncionarios: qtdFuncionarios ? qtdFuncionarios.qtdFuncionariosAtivos : 0,
              quantidadeHistoricaFuncionarios: qtdFuncionarios ? qtdFuncionarios.qtdHistoricaFuncionarios : 0,
            }
          })
          setEstruturasOrganizacionais(estruturasComQuantidadeFuncionarios)
        } else {
          setEstruturasOrganizacionais(data.data.list)
        }
        setLoading(false)
      } catch (error) {
        console.error('Erro ao ativar/desativar estrutura organizacional.')
      }
    }
    setTreeAction((value, tipo) => {
      if (tipo === 'show') {
        setIsTabelaNormal(value)
        setShowOnlyAtivos(value)
      } else if (tipo === 'ativar/desativar' && value) {
        const paisAtivos = (estrutura) => {
          if (!estrutura.estruturaOrganizacionalPai)
            return estrutura.ativo
          if (!estrutura.ativo)
            return false
          if (estrutura.estruturaOrganizacionalPai)
            return paisAtivos(estrutura.estruturaOrganizacionalPai)
        }

        if (value.estruturaOrganizacionalPai && !value.ativo) {
          const isPaisAtivos = paisAtivos(value.estruturaOrganizacionalPai)
          if (!isPaisAtivos) {
            alert.error('Não é possível ativar esta estrutura. Verifique se todas as estruturas pais relacionadas a esta estrutura estão ativadas.')
            return
          }
        }
        handleAtivar(value.id, !value.ativo)
      }
    })
  }, [setTreeAction, showOnlyAtivos, path, alert, enableTotals])

  useEffect(() => {
    const syncFilter = async () => {
      const allFiltersAreEmpty = Object.values(filtro).every((filter) => filter.value.slice(7).trim() === '')
      const url = `${path}?limit=2000&offset=0${!allFiltersAreEmpty ? `&filter=${encodeURIComponent(JSON.stringify(filtro))}` : ''}`
      try {
        const { data } = await Axios.get(url)
        setIsTabelaNormal(!allFiltersAreEmpty ? true : false)
        if (enableTotals) {
          const qtdFuncionarios = `${path}/total`
          const { data: qtd } = await Axios.get(qtdFuncionarios)
          const estruturasComQuantidadeFuncionarios = data.data.list.map((estrutura) => {
            const qtdFuncionarios = qtd.data.find((quantidade) => quantidade.estruturaOrganizacionalId === estrutura.id)
            return {
              ...estrutura,
              quantidadeFuncionarios: qtdFuncionarios ? qtdFuncionarios.qtdFuncionariosAtivos : 0,
              quantidadeHistoricaFuncionarios: qtdFuncionarios ? qtdFuncionarios.qtdHistoricaFuncionarios : 0,
            }
          })
          setEstruturasOrganizacionais(estruturasComQuantidadeFuncionarios)
        } else {
          setEstruturasOrganizacionais(data.data.list)
        }
      } catch (error) {
        console.error(error)
      }
    }
    syncFilter()
  }, [filtro, path, enableTotals])

  return (
    loading ? <LoadingPage /> :
      <Table bordered hover size="sm">
        <thead>
          <tr className='bg-light'>
            {columns.map((column, index) => (
              <th key={index} className='text-center'>
                {column.header}
                {index > 0 && column.property !== 'qtd' && (
                  <input key={index} type='text' className='form-control form-control-sm mt-1' placeholder='Filtro' onChange={(e) => handleFilter(column.property, e.target.value)} />
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {estruturasOrganizacionais &&
            estruturasOrganizacionais.map((estruturaOrganizacional) => {
              if (estruturaOrganizacional.estruturaOrganizacionalPai && !isTabelaNormal) return null
              if (showOnlyAtivos && !estruturaOrganizacional.ativo) return null
              return renderizarEstrutura(estruturaOrganizacional)
            })}
        </tbody>
      </Table>
  )
}
